import { idsInSameOrder } from './idsInTheSameOrder';
import { isEqual } from 'lodash';

export function mergeByKey<T extends Record<string, any>>(
  prev: T[],
  next: T[],
  key: string
): { changed: boolean; data: T[] } {
  if (!prev || prev.length === 0) {
    return { changed: true, data: next };
  }

  const sameIdsSameOrder = idsInSameOrder(prev, next, key);
  if (sameIdsSameOrder) {
    let anyRowChanged = false;
    const merged = next.map((n, i) => {
      const p = prev[i];
      if (isEqual(p, n)) {
        return p;
      } else {
        anyRowChanged = true;
        console.log('row changed', { previous: p, new: n });
        return n;
      }
    });
    if (!anyRowChanged) {
      return { changed: false, data: prev };
    }
    return { changed: true, data: merged };
  }

  const prevMap = new Map(prev.map((p) => [p?.[key], p]));
  let anyChanged = prev.length !== next.length;
  const merged = next.map((n) => {
    const p = prevMap.get(n?.[key]);
    if (p && isEqual(p, n)) {
      return p;
    } else {
      anyChanged = true;
      return n;
    }
  });
  return { changed: anyChanged, data: merged };
}
